(() => {
  const root = document.querySelector('[data-store-reviews-list]');
  if (!root) return;

  const items = [...root.querySelectorAll('[data-store-review-item]')];
  const perPage = Number.parseInt(root.dataset.perPage, 10) || 10;
  if (items.length <= perPage) return;

  const totalPages = Math.ceil(items.length / perPage);
  let page = 1;

  const prev = document.querySelector('[data-store-reviews-prev]');
  const next = document.querySelector('[data-store-reviews-next]');
  const label = document.querySelector('[data-store-reviews-page-label]');

  const render = () => {
    items.forEach((item, index) => {
      const itemPage = Math.floor(index / perPage) + 1;
      item.classList.toggle('hidden', itemPage !== page);
    });
    if (prev) prev.disabled = page <= 1;
    if (next) next.disabled = page >= totalPages;
    if (label) {
      const template = label.dataset.pageTemplate || 'Page __CURRENT__ of __TOTAL__';
      label.textContent = template.replace('__CURRENT__', page).replace('__TOTAL__', totalPages);
    }
  };

  prev?.addEventListener('click', () => {
    if (page > 1) {
      page -= 1;
      render();
    }
  });
  next?.addEventListener('click', () => {
    if (page < totalPages) {
      page += 1;
      render();
    }
  });
})();
